import React, { useState, useRef } from 'react';
import { Grid, Theme, Dialog } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { PlayCircleFilled } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';

export interface BlogProps {
  data: {
    img: string;
    title: string;
    author: string;
    authorImg: string;
    date: string;
    duration: string;
    url: string;
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    color: 'inherit',
    boxShadow: theme.shadows[3],
    marginRight: 32,
    '&:last-child': {
      marginRight: 0,
    },
  },
  coverImg: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: 294,
    height: 150,
  },
  blogContent: {
    padding: 8,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
    maxWidth: 294,
  },
  blogTitle: {
    fontSize: 16,
  },
  authorBox: {
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
  },
  authorImg: {
    height: 28,
    marginRight: 10,
    borderRadius: '50%',
  },
  blogDetailsWrapper: {
    color: theme.specialColors.ICON_DEFAULT_COLOR,
  },
  authorName: {
    fontSize: 12,
  },
  blogDetails: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 11,
  },
}));

export const BlogCard = (props: BlogProps) => {
  const classes = useStyles();

  return (
    <a className={classes.root} href={props.data.url} target="_blank" rel="noreferrer">
      <div style={{ backgroundImage: `url(${props.data.img})` }} className={classes.coverImg} />
      <div className={classes.blogContent}>
        <div className={classes.blogTitle}>{props.data.title}</div>
        <div className={classes.authorBox}>
          {props.data.author && (
            <img src={props.data.authorImg} className={classes.authorImg} alt={props.data.author} />
          )}
          <div className={classes.blogDetailsWrapper}>
            {props.data.author && <div className={classes.authorName}>{props.data.author}</div>}
            <div className={classes.blogDetails}>
              <div>{props.data.date}</div>
              <div>&nbsp;&#8226;&nbsp;</div>
              <div>{props.data.duration}</div>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};
